// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__1C54z","signatureBlock":"Footer_signatureBlock__3zOWa","signature":"Footer_signature__3HfeB"};